import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M11 7.00018H2V9.00018H11V7.00018ZM11 15.0002H2V17.0002H11V15.0002ZM16.34 11.0002L12.8 7.46018L14.21 6.05018L16.33 8.17018L20.57 3.93018L22 5.34018L16.34 11.0002ZM16.34 19.0002L12.8 15.4602L14.21 14.0502L16.33 16.1702L20.57 11.9302L22 13.3402L16.34 19.0002Z" fill="black"/>
</svg>
;
